// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","2690":"1009f95d","5969":"570f2b94","7853":"ac6d9960","8938":"375eaff4","9132":"ac6d9960"}[chunkId] + ".chunk.css";
};